module.exports = __webpack_public_path__ + "static/img/quote_2.90b5a2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/quote_2.png
// module id = HDJS
// module chunks = 1